var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"educational-value"},[(_vm.status)?_c('img',{attrs:{"src":require("@/assets/img/icons/done-e.svg"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/img/icons/cancel-e.svg"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }